import GenericLabResultsQuestions from './Lab/question';
import genericHeightWeightQuestions from './HeightWeight/question';
import genericTerminalQuestions from './terminals/questions';

export type { GenericHeightWeightQuestionFieldAnswers } from './HeightWeight/question';
export type { GenericLabResultsQuestionAnswerFields } from './Lab/question';
export type { GenericTerminalQuestionFieldAnswers } from './terminals/questions';

/**
 * @description: Generic Questions that share functionality amongst multiple questionnaire.
 * @example Re-usedDisqualifying slides, re-used components (BMI).
 */
const GenericQuestions = [
  ...GenericLabResultsQuestions,
  ...genericHeightWeightQuestions,
  ...genericTerminalQuestions
];
export default GenericQuestions;
